import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, List, message, Modal, Input } from "antd";
import { useTranslation } from "react-i18next";
import { connect } from "dvajs";
import { ListItem, Loading } from "@jd/focus-desktop-comps";
import { openUserCardModal } from "../../AddressBook/common";
import { debounce, trim as lodashTrim, uniqBy } from "lodash";
import IconFont, { IconSearch } from "../../icon";
import { FocusSDK as focusSDK, isFocusEnv, isLinuxOs, useDebounce } from "@/utils";
import cookies from "js-cookie";
import "./index.less";
import { Employee, Group, GroupAttribute, Session, UID } from "@/types/chat";
import ImService from "@/server/ImService";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { searchRobot } from "@/api/search";
import { groupBotAdd } from "@/api/egroup";
import { UserCardPayload } from "@/models";
import { getDeptPositionDesc } from "@/models/user";
import { changeEgovUrl } from "@/utils/tools";
import { LoadMore } from "@jd/focus-desktop-comps/lib/es/List";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { checkTelephone } from "@/utils/chat";
import bus from "@/utils/bus";
import { PlusCircleFilled } from "@/utils/antdIcon";

const pageSize = 50;

function RobotModal({
  addRobotModalVisible,
  openAddRobotModal,
  addRobotModalGroupId,
  addRobotModalInputValue,
  setAddRobotModalInputValue,
  toggleUserCardModal,
  groupRobots,
  selectedSession
}: {
  addRobotModalVisible: boolean;
  openAddRobotModal: Function;
  addRobotModalGroupId: string;
  addRobotModalInputValue: string;
  setAddRobotModalInputValue: Function;
  toggleUserCardModal: Function;
  groupRobots: any[];
  selectedSession: any;
}) {
  const { t } = useTranslation("common");
  const { t: chatT } = useTranslation("chat");
  const [robotList, setRobotList] = useState<ListItemData[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(addRobotModalInputValue);
  const [hasMore, setHasMore] = React.useState(false);
  const [needMask, setNeedMask] = React.useState(false);
  const pageNoRef = React.useRef<number>(1);

  function cancelHandler() {
    openAddRobotModal({ visible: false });
  }
  useEffect(() => {
    if (!addRobotModalVisible) {
      setSearchValue("");
      setRobotList(null);
      pageNoRef.current = 1;
      setNeedMask(false);
    }
    if (searchValue) {
      setAddRobotModalInputValue("");
    }
    if (checkTelephone(searchValue)) {
      setNeedMask(true);
    } else {
      setNeedMask(false);
    }
  }, [addRobotModalVisible, searchValue, setAddRobotModalInputValue]);

  const openUserCard = (data: any) => {
    console.log("openUserCard data:", data);
    const { botId, teamId, appId } = data || {};

    toggleUserCardModal({
      visible: true,
      userId: botId,
      teamId,
      appId,
      // robotData: data,
      footExtra: groupRobots.find((itm) => itm.botId === botId) ? null : (
        <Button
          type="primary"
          onClick={(e) => {
            handleAddRobot(e, data, true);
          }}
        >
          添加至群组
        </Button>
      )
    });
  };

  const handleSearch = useCallback(() => {
    if (!searchValue) {
      return;
    }
    setLoading(true);
    searchRobot({
      keyword: searchValue,
      pageNo: pageNoRef.current,
      pageSize: pageSize
    })
      .then((res: any) => {
        if (!res) {
          setRobotList([]);
          return;
        }

        const data: any = (res.botList || []).map((item: any) => {
          return {
            ...item,
            id: item?.titleId,
            name: item?.botName,
            avatar: item?.avatar,
            desc: item.description,
            isLeader: item?.isleader,
            labelInfoList: item?.labelInfoList || [],
            concatsType: item.concatsType // 跨平台接口人类型, -1: 默认值，正常账号, 0: 跨平台法人单位接口人，1：跨平台单位公用账号接口人
          };
        });

        const newRobots = robotList ? [...robotList, ...data] : data;
        setRobotList(
          uniqBy(newRobots, (item: any) => {
            return item.botId + item.appId + item.botCode;
          })
        );
        setHasMore(res.botList?.length >= pageSize);
      })
      .catch(async (e) => {
        const netServer = NetworkCheck.getInstance({
          url: getNetCheckUrl(),
          checkType: UseCheckType.API
        });
        const onLine = await netServer.checkNet();
        if (onLine) {
          message.error({
            content: `${e}`
          });
        } else {
          message.error(t("Network Error"));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [robotList, searchValue, t]);

  useEffect(() => {
    if (addRobotModalInputValue) {
      setSearchValue(addRobotModalInputValue);
      handleSearch();
    }
  }, [addRobotModalInputValue, handleSearch]);

  let loadMore = null;
  if (hasMore) {
    loadMore = (
      <LoadMore
        onClick={() => {
          pageNoRef.current = pageNoRef.current + 1;
          handleSearch();
        }}
      >
        {t("list.loadMore")}
      </LoadMore>
    );
  } else {
    loadMore = <LoadMore>{t("list.noMore")}</LoadMore>;
  }

  const handleAddRobot = debounce((e, item, closeUserCard?) => {
    e.stopPropagation();
    let authInfo = focusSDK.authInfo;
    console.log("authInfo", focusSDK.authInfo);
    groupBotAdd({
      groupId: addRobotModalGroupId,
      nickName: authInfo?.realName || "",
      botList: [
        {
          botId: item.botId,
          teamId: item.teamId,
          app: item.appId
        }
      ]
    })
      .then(async (res) => {
        console.log("addrobotRes:", res);
        // bus.emit("chat:load-group-robots", { gid: addRobotModalGroupId });
        message.success("添加成功");
        // sendInviteApply([
        //   { pin: item.botId, teamId: item.teamId, app: item.app }
        // ]);
        // openAddRobotModal({ visible: false });
        const result = await ImService.getInstance().handleGroupMemberInMessage(
          selectedSession.sessionId,
          [{ app: item.appId, pin: item.botId, teamId: item.teamId }],
          { noSaveDB: false }
        );
        console.log("invite robot result:", result);
        toggleUserCardModal({ visible: false });
      })
      .catch((e) => {
        console.log("addrobot error", e);
        message.error(e.message);
      });
  }, 500);

  return (
    <Modal
      title={t("createButton.addRobot")}
      width="480px"
      bodyStyle={{ width: 480, maxHeight: 340, padding: 24, minHeight: 46 }}
      visible={addRobotModalVisible}
      footer={null}
      onCancel={cancelHandler}
      centered={true}
    >
      <div
        className="addRobot-wrap"
        style={{ minHeight: robotList && robotList.length > 0 ? "auto" : "72px" }}
      >
        <div className="addRobotSearchInput ">
          <div className="search-robot-container-input">
            <Input
              prefix={<IconFont type="iconapp_ic_search" style={{ color: "#848484" }} />}
              placeholder={t("search.iconTextAppRobot")}
              className="input-box"
              value={searchValue}
              allowClear
              onChange={(e) => {
                pageNoRef.current = 1;
                setRobotList(null);
                setSearchValue(e.target.value);
              }}
              maxLength={100}
              onPressEnter={handleSearch}
            />
          </div>
          <Button
            className="addRobot-btn"
            type="primary"
            // loading={loading}
            onClick={handleSearch}
            disabled={!searchValue}
          >
            {t("search.iconText")}
          </Button>
        </div>
        <div className="robot-body">
          {loading && <Loading style={{ marginTop: 10 }} />}
          {robotList ? (
            robotList.length > 0 ? (
              // robotList.length > 0 ? (
              //     robotList?.map((item, key) => {
              //         let newItem = item;
              //         if (newItem.avatar) {
              //             newItem.avatar = changeEgovUrl(newItem.avatar);
              //         }
              //         return (
              //             <div key={key}>

              //                 <ListItem
              //                     data={newItem}
              //                     onClick={debounce(() => {
              //                         openUserCardModal(item);
              //                     }, 500)}
              //                 />
              //             </div>
              //         );
              //     })

              <List
                dataSource={robotList || []}
                loadMore={loadMore}
                renderItem={(item: any) => {
                  let newItem = item;
                  if (newItem.avatar) {
                    newItem.avatar = changeEgovUrl(newItem.avatar);
                  }
                  return (
                    <ListItem
                      data={newItem}
                      onClick={debounce(() => {
                        let needMaskName = false;
                        if (item.concatsType === 0) needMaskName = true;
                        // openUserCardModal({
                        //   ...item,
                        //   needMask,
                        //   needMaskName,
                        //   robotId: newItem.botId
                        // });
                        openUserCard(item);
                      }, 500)}
                      extra={
                        groupRobots.find((itm) => itm.botId === newItem.botId) ? (
                          <div>已添加</div>
                        ) : (
                          <div
                            className="add-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddRobot(e, newItem);
                            }}
                          >
                            <PlusCircleFilled />
                          </div>
                        )
                      }
                    />
                  );
                }}
              />
            ) : (
              <div className="robot-nodata">
                <h4>无法找到该用户</h4>
                <p>
                  1、仅支持精准搜索姓名或手机号，如“张三”或者“13800000000”，请检查关键词是否输入正确
                  <br />
                  2、对方可能未使用{(window as any)?._BTS_CONFIG?.REACT_APP_NAME ||
                  ""}或因隐私设置无法被搜索
                </p>
              </div>
            )
          ) : (
            ""
          )}
        </div>
      </div>
    </Modal>
  );
}
function mapStateToProps({ ebook, chat }: any) {
  return {
    addRobotModalVisible: ebook.addRobotModalVisible,
    addRobotModalInputValue: ebook.addRobotModalInputValue,
    addRobotModalGroupId: ebook.addRobotModalGroupId,
    groupRobots: chat.groupRobots,
    selectedSession: chat.selectedSession
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openAddRobotModal(data: any) {
      dispatch({ type: "ebook/openAddRobotModal", payload: data });
    },
    setAddRobotModalInputValue(data: any) {
      dispatch({ type: "ebook/setAddRobotModalInputValue", payload: data });
    },
    toggleUserCardModal(payload: UserCardPayload) {
      dispatch({ type: "app/toggleUserCardModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RobotModal);
